query($sessionId: [String]) {
    wishlistItems: wishlists(sessionId: $sessionId) {
        items {
            elementId
            title
        }
    }
}
